function Banner(props: any) {
  return (
    <div className={"loop-banner" + (props.className ? " " + props.className : "")}>
      {props.children}
    </div>
  );
}

function Title(props: any) {
  return (
    <div className={"loop-banner-title" + (props.className ? " " + props.className : "")}>
      {props.children}
    </div>
  );
}

function Body(props: any) {
  return (
    <div className={"loop-banner-body" + (props.className ? " " + props.className : "")}>
      {props.children}
    </div>
  );
}

function Footer(props: any) {
  return (
    <div className={"loop-banner-footer" + (props.className ? " " + props.className : "")}>
      {props.children}
    </div>
  );
}

function Ribbon(props: any) {
  return (
    <div className={"loop-banner-ribbon" + (props.className ? " " + props.className : "")} id={props.id ? props.id : null}>{props.children}</div>
  );
}

function Reward(props: any) {
  return (
    <div className={"loop-banner-reward" + (props.className ? " " + props.className : "")}>{props.children}</div>
  );
}

export default Object.assign(Banner, {
  Reward: Reward,
  Ribbon: Ribbon,
  Title: Title,
  Body: Body,
  Footer: Footer
});
